

function Badge() {
    const padlock = padlockicon;
    return (
        <div className="wpb_single_image wpb_content_element vc_align_  badge-sme">
            <figure className="wpb_wrapper vc_figure">
                <div className="vc_single_image-wrapper   vc_box_border_grey"> 
                    <img src={padlock} className="vc_single_image-img attachment-thumbnail" alt="" loading="lazy" height="24" width="18" /> 
                </div>
            </figure>
        </div>
    )
}

export default Badge
